<script lang="ts">
    import {authFetch} from "../Auth";
    import {strToLocaleDateTime} from "../Utils";
    import {getRouteById} from "../Nav";
    import {overlay} from "../Store";
    import Sort from "../Component/Sort.svelte";

    export const params = {}
    let list: any[] = []
    let count: number = 0
    let listPromise: Promise<any>
    let totalAvailable = 0;
    let totalReady = 0;
    let totalFlood = 0;
    let bannedAtLastTwoDays = 0;

    let filter = {
        offset: 0,
        limit: 75,
        order: "ASC",
        orderBy: "id",
        is_active: true
    }
    async function loadList() {
        let response = await authFetch('app/list', {
            method: 'POST',
            body: JSON.stringify(filter),
        })
        if (response.ok) {
            let data = await response.json()
            list = data.list
            count = data.count
            totalAvailable = data.total_available
            totalFlood = data.total_flood
            totalReady = data.total_ready
            bannedAtLastTwoDays = data.banned_at_last_two_days
        } else {
            alert(response.statusText)
        }
    }

    function update(){
        listPromise = loadList()
    }

    function onSort(ev: Event){
        if(ev.detail.order === null){
            filter.order = "ASC"
            filter.orderBy = "id"
        } else {
            filter.order = ev.detail.order
            filter.orderBy = ev.detail.orderBy
        }
        update()
    }
    update();
</script>
<style>
    .table {
        word-break: break-word;
    }
    .account-stat span {
        padding: 0 5px;
    }
</style>
<table class="table table-bordered table-sm mt-3 text-center">
    <thead class="position-sticky bg-white shadow" style="z-index: 1030; top: 56px; vertical-align: middle">
        <tr style="border: 0px;">
            <th colspan="9" style="border: 0px;">
                <div class="text-start account-stat">
                    <span>К-сть розсильників:</span>
                    <span>Працюють: {totalAvailable}</span>
                    <span>На фармі: {totalReady}</span>
                    <span>Флуд: {totalFlood}</span>
                    <span>Бан за 2 дні: {bannedAtLastTwoDays}</span>
                </div>
            </th>
            <th colspan="9" style="border: 0px;">
                <div class="input-group justify-content-end">
                    <label class="btn btn-primary">
                        <input type="checkbox" class="form-check-input" autocomplete="off"
                               bind:checked={filter.is_active} on:change={update}>
                        Активні
                    </label>
                    <button class="btn btn-info"
                            class:disabled={filter.offset===0}
                            on:click={()=>{filter.offset-=filter.limit;update()}}>
                        <i class="bi bi-chevron-left"></i>
                    </button>
                    <input class="form-control flex-grow-0" type="number" style="width: 5em;"
                           min="1"
                           max={Math.floor(count / filter.limit)+1}
                           step="1"
                           value={(filter.offset / filter.limit)+1}
                           on:change={(ev)=>{filter.offset=(ev.target.value - 1) * filter.limit; update()}}
                    >
                    <button class="btn btn-info disabled">
                        / {Math.floor(count / filter.limit)+1}
                    </button>
                    <button class="btn btn-info"
                            class:disabled={list.length < filter.limit}
                            on:click={()=>{filter.offset+=filter.limit;update()}}>
                        <i class="bi bi-chevron-right"></i>
                    </button>
                </div>
            </th>
        </tr>
        <tr style="font-size: 14px;">
            <th rowspan="2" style="width: 2%">#</th>
            <th rowspan="2" style="width: 4%">ID</th>
            <th rowspan="2" style="width: 8%">Тел</th>
            <th rowspan="2" style="width: 5%">Ім'я</th>
            <th rowspan="2" style="width: 5%">Прізвище</th>
            <th rowspan="2" style="width: 7%">Дата бану<Sort orderBy="banned_at" state={filter} orders={["ASC","DESC"]} on:sort={onSort}></Sort></th>
            <th rowspan="2" style="width: 15%">Повідомлення бану</th>
            <th rowspan="2" style="width: 6%">Бан за флуд до</th>
            <th rowspan="2" style="width: 5%">Аватар</th>
            <th rowspan="2" style="width: 6%">Створено</th>
            <th colspan="6">Статистика по відправках</th>
            <th colspan="2">AI фарм</th>
        </tr>
        <tr style="font-size: 14px;">
            <th style="width: 4%">Всього</th>
            <th style="width: 4%">Успішно</th>
            <th style="width: 5%">Успішно взаємодія</th>
            <th style="width: 5%">Успішно без взаємодії</th>
            <th style="width: 5%">Помилка без тел</th>
            <th style="width: 5%">Помилка інша</th>
            <th>К-сть чатів</th>
            <th>К-сть повідомлень</th>
        </tr>
    </thead>
    <tbody>
    {#await listPromise}
        <tr>
            <td colspan="1000" class="text-center">
                <div class="spinner-grow"></div>
            </td>
        </tr>
    {:then _}
        {#if list.length > 0}
            {#each list as app, i}
                <tr>
                    <td rowspan="2">{i+1}</td>
                    <td rowspan="2">{app.id}</td>
                    <td rowspan="2">{app.phone}</td>
                    <td rowspan="2">{app.first_name ?? '-'}</td>
                    <td rowspan="2">{app.last_name ?? '-'}</td>
                    <td rowspan="2">{strToLocaleDateTime(app.banned_at)}</td>
                    <td rowspan="2" >{app.ban_message ?? '-'}</td>
                    <td rowspan="2">
                        {#if app.banned_till}
                            {strToLocaleDateTime(app.banned_till)}
                        {:else}
                            -
                        {/if}
                    </td>
                    <td rowspan="2">
                        {#if app.thumbnail}
                            <img src="data:image/jpeg;base64,{app.thumbnail}" width="60" height="60">
                        {:else}
                            -
                        {/if}
                    </td>
                    <td rowspan="2">{strToLocaleDateTime(app.created_at)}</td>
                </tr>
                <tr>
                    <td>{app.message_stats.total ?? '0'}</td>
                    <td>{app.message_stats.success ?? '0'}</td>
                    <td>{app.message_stats.success_has_interaction ?? '0'}</td>
                    <td>{app.message_stats.success_without_interaction ?? '0'}</td>
                    <td>{app.message_stats.fail_hidden_phone ?? '0'}</td>
                    <td>{app.message_stats.fail_other ?? '0'}</td>
                    <td>{app.ai_chats ?? 0}</td>
                    <td>{app.ai_chat_messages ?? 0}</td>
                </tr>
            {/each}
        {:else}
            <tr>
                <td colSpan="1000" class="text-center">
                    <div class="alert alert-secondary">Немає акаунтів</div>
                </td>
            </tr>
        {/if}
    {/await}
    </tbody>
</table>